import { render, staticRenderFns } from "./sent.vue?vue&type=template&id=54467a56"
import script from "./sent.vue?vue&type=script&lang=js"
export * from "./sent.vue?vue&type=script&lang=js"
import style0 from "./sent.vue?vue&type=style&index=0&id=54467a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports